

export const init = initialFilter => initialFilter;

export const ACTIONS = {
  SET_SITES: "site/SET_SITES",
  LOADING: "site/LOADING",
  SET_OVERVIEW: "site/SET_OVERVIEW",
  SET_TOP_SITES: "site/SET_TOP_SITES",
  SET_ERROR: "site/SET_ERROR"
};

export const reducer = (state = {}, action) => {
  const { type, payload } = action;

  switch (type) {
    case ACTIONS.SET_SITES: {
      return {
        ...state,
        sites: payload.sites,
        actionsState: payload.actionsState,
        appGroup: payload.appGroup,
        showLoader: false,
        ACTION: ACTIONS.SET_OVERVIEW
      };
    }
    case ACTIONS.LOADING: {
      return {
        ...state,
        showLoader: true
      };
    }
    case ACTIONS.SET_ERROR: {
      return {
        ...state,
        ...payload
      };
    }
    case ACTIONS.SET_OVERVIEW: {
      return {
        ...state,
        ACTION: ACTIONS.SET_OVERVIEW
      };
    }
    case ACTIONS.SET_TOP_SITES: {
      return {
        ...state,
        ACTION: ACTIONS.SET_TOP_SITES
      };
    }
    default:
      return state;
  }
};

export default reducer;
